<div class="row overflow-auto w-100 h-100">
  <div class="col-12 container-fluid overflow-auto">
    <div class="d-flex justify-content-center">
      <h2 class="m-2 text-center">최근 업데이트</h2>
    </div>

    <div class="d-flex container-fluid">
      @if(this.recent) {
      <div class="row">
        @for (card of this.recent; track card) {
        <app-card-item
          [cardInfo]="card"
          [pathType]="
            card.cardType.startsWith('P') ? '/pcardinfo' : '/scardinfo'
          "
          [isHome]="true"
          class="col-12 col-md-6 col-lg-4 col-xl-3 p-1"></app-card-item>
        }
      </div>
      }
    </div>
    <div class="d-flex justify-content-center">
      <h2 class="m-2 text-center">CD 정보</h2>
    </div>
    <div class="d-flex container-fluid row justify-content-center m-auto">
      <div class="col-md-none col-lg-1"></div>
      <div class="row g-2 col-12 col-lg-10">
      @for(cd of this.cdInfo; track cd) {
        <app-cd-info [cdInfo]="cd"
          class="col-6 col-sm-4 col-md-4 col-lg-3"></app-cd-info>
      }
      </div>
      <div class="col-md-none col-lg-1"></div>
    </div>
    <div class="d-flex justify-content-center">
      <h2 class="m-2 text-center">콘서트 정보</h2>
    </div>
    <div class="d-flex row row-cols-sm-1 row-cols-md-2 g-2">
      @for(live of this.liveInfo; track live) {
      <app-live-info [liveInfo]="live"></app-live-info>
      }
    </div>
  </div>
</div>
